export * from './LocationResultsListsV2XS';
